<!--
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2024-06-28 13:27:43
 * @LastEditors: Haoxiwei 1078734933@qq.com
 * @LastEditTime: 2024-07-31 10:20:52
 * @FilePath: /wemeet-admin-new/src/views/data/components/aiTrendAnalysis.vue
 * @Description: 
 * Copyright (c) 2024 by WeMeet, All Rights Reserved. 
-->
<template>
  <div class="dialogCard" style="margin-top: 20px; width: 100%">
    <div class="subBox">
      <div class="title">
        <span>趋势分析</span>
        <!-- <el-tooltip effect="dark" content="用户访问人数、报名、签到等关键数据，连续多天的趋势" placement="top-start">
          <img src="https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/WeMeet-Static/WeMeet-mini/tips.png" alt="" class="tipsIcon">
        </el-tooltip> -->
      </div>
      <div class="chooseTime">
        <span class="timeLabel">选择时间</span>
        <el-date-picker
          v-model="timeRange"
          :disabled-date="disabledDate"
          end-placeholder="结束时间"
          range-separator="-"
          :shortcuts="shortcuts"
          start-placeholder="开始时间"
          type="daterange"
          @calendar-change="handleChange"
          @change="pickerChange"
          @focus="handleFocus"
        />
      </div>
    </div>

    <el-row>
      <div v-if="loading">加载中...</div>
      <template v-else>
        <el-col v-if="!emptyFlag" :lg="24" :md="24" :sm="24" :xl="24" :xs="24">
          <vab-chart :option="option" style="height: 390px; width: 100%" theme="vab-echarts-theme" />
        </el-col>
        <el-col
          v-else
          :lg="24"
          :md="24"
          :sm="24"
          style="display: flex; align-items: center; justify-content: center; flex-direction: column"
          :xl="24"
          :xs="24"
        >
          <img
            alt=""
            src="https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/WeMeet-Static/im/imNoData.png"
            style="width: 300px; height: 200px"
          />
          <div style="margin-top: 20px; color: #333; font-size: 20px; font-weight: bold">暂无数据</div>
        </el-col>
      </template>
    </el-row>
  </div>
</template>

<script>
  import { defineComponent, reactive, toRefs, watch } from 'vue'
  import _ from 'lodash'
  import VabChart from '@/extra/VabChart'
  import VabCount from '@/extra/VabCount'

  export default defineComponent({
    components: {
      VabChart,
      VabCount,
    },
    props: {
      aiData: {
        type: Object,
        default: {},
      },
    },
    setup(props, { emit }) {
      watch(
        () => props.aiData,
        (newVal, oldVal) => {
          if (newVal.aiAgentDataTrendVos.length == 0) {
            state.emptyFlag = true
          } else {
            handleOption(newVal.aiAgentDataTrendVos)
          }
          setTimeout(() => {
            state.loading = false
          }, 100)
        }
      )

      const handleOption = (data) => {
        let xData = []
        let seriesData = [
          {
            name: '访问人数',
            type: 'line',
            stack: 'Total',
            showSymbol: false,
            data: [],
          },
          {
            name: '访问次数',
            type: 'line',
            stack: 'Total',
            showSymbol: false,
            data: [],
          },
          {
            name: '会话次数',
            type: 'line',
            stack: 'Total',
            showSymbol: false,
            data: [],
          },
        ]
        data.forEach((v) => {
          xData.push(v.date)
          seriesData[0].data.push(v.meetingAiAgentNum)
          seriesData[1].data.push(v.meetingAiAgentTimes)
          seriesData[2].data.push(v.meetingAiAgentSessionNum)
        })
        state.option.xAxis.data = xData
        state.option.series = seriesData
      }
      const state = reactive({
        emptyFlag: false,
        loading: true,
        timeRange: [null, null],
        option: {
          tooltip: {
            trigger: 'axis',
          },
          legend: {
            data: ['访问人数', '访问次数', '会话次数'],
            left: `center`,
            top: 'bottom',
            orient: 'horizontal',
          },
          grid: {
            left: 30,
            right: 30,
            top: 80,
            bottom: 50,
            containLabel: true, // 如果使用坐标轴刻度标签也应当保证适应
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: [],
            axisLabel: {
              show: true,
              fontSize: 10,
              interval: 0,
            },
          },
          yAxis: {
            type: 'value',
            name: '单位（人）',
            nameTextStyle: {
              color: '#4e5969',
            },
            axisLabel: {
              formatter: '{value}',
            },
          },
          series: [],
        },
      })

      window.onresize = () => {
        console.log(`resize`)
      }

      const handleChange = (val) => {
        const [pointDay] = val
        state.chooseDay = pointDay
      }

      const pickerChange = (val) => {
        console.log(val, '=-==')
        emit('changeTrends', val)
      }
      //取值方法
      const handleFocus = () => {
        state.chooseDay = null
      }
      const disabledDate = (time) => {
        if (!state.chooseDay) {
          return false
        }
        let timeRange = 30
        const con1 = new Date(state.chooseDay).getTime() - timeRange * 24 * 60 * 60 * 1000
        const con2 = new Date(state.chooseDay).getTime() + timeRange * 24 * 60 * 60 * 1000
        return time < con1 || time > con2
      }

      return {
        ...toRefs(state),
        handleChange,
        handleFocus,
        disabledDate,
        pickerChange,
      }
    },
  })
</script>

<style lang="scss" scoped>
  .dialogCard {
    width: 100%;
    min-height: 174px;
    background: #ffffff;
    border-radius: 4px 4px 4px 4px;
    padding: 20px;
    box-sizing: border-box;
    .subBox {
      display: flex;
      justify-content: space-between;
      .title {
        font-weight: 500;
        font-size: 16px;
        color: #1d2129;
        margin-bottom: 4px;
        display: flex;
        align-items: center;
        .tipsIcon {
          width: 18px;
          height: 18px;
          margin-left: 8px;
        }
      }
      .chooseTime {
        .timeLabel {
          font-size: 14px;
          color: #4e5969;
          margin-right: 16px;
        }
      }
    }
  }
</style>
